import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as teamActions from '../team.actions';
import { getScoresForCurrentUserTeam, getTotalScoreForCurrentUserTeam } from '../team.selectors';
import { getCurrentUser } from '../../user/user.selectors';

import Table from '../../common/components/Table';
import {Localize} from '../../../locale/localization';

class TeamScoresBlock extends Component {
  componentWillMount = () => {
    const {
      getTeam,
      currentUser,
    } = this.props;

    getTeam(currentUser.team);
  }

  refresh = () => {
    const {
      invalidateTeam,
      currentUser
    } = this.props;

    invalidateTeam(currentUser.team);
  }

  renderUserRow = (user) => {
    const {
      _id,
      firstName,
      lastName,
      email,
      score,
    } = user;
    
    const displayName = firstName && lastName ? `${firstName} ${lastName}` : email;

    return (
      <tr key={_id}>
        <td>{displayName}</td>
        <td>{score} p</td>
      </tr>
    );
  }

  renderTableFooter = () => {
    const { teamTotalScore } = this.props;
    return (
      <tr>
        <td>{Localize('team.score.total')}</td>
        <td>{teamTotalScore} p</td>
      </tr>
    );
  }

  render() {
    const {
      teamUsers
    } = this.props;

    return (
      <div>
        {/*<header>
          <a onClick={this.refresh}>Päivitä</a>
        </header>*/}
        <Table
          items={teamUsers}
          renderItem={this.renderUserRow}
          renderFooter={this.renderTableFooter}
        />
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  const currentUser = getCurrentUser(state);
  const teamUsers = getScoresForCurrentUserTeam(state);
  const teamTotalScore = getTotalScoreForCurrentUserTeam(state);
  return {
    currentUser,
    teamUsers,
    teamTotalScore,
  };
};

const ConnectedTeamScoresBlock = connect(
  mapStateToProps,
  Object.assign({}, teamActions),
)(TeamScoresBlock);

export default ConnectedTeamScoresBlock;


// WEBPACK FOOTER //
// ./src/modules/team/components/TeamScoresBlock.js